import firebase from 'firebase'
import { v4 as uuid } from 'uuid'

const config = {
  apiKey: 'AIzaSyAIEmJY4BTTyE5rhF70_5gRDWtWJi25rNY',
  authDomain: 'voicemed-791a3.firebaseapp.com',
  databaseURL: 'https://voicemed-791a3.firebaseio.com',
  projectId: 'voicemed-791a3',
  storageBucket: 'voicemed-791a3.appspot.com',
  messagingSenderId: '326281896924',
  appId: '1:326281896924:web:1a7b695be2530a07d72519'
}

firebase.initializeApp(config)

const storage = firebase.storage()

export const upload = ({ blobs, age, gender, healthStatus, conditions, symptoms }) => {
  const storageRef = process.env.NODE_ENV === 'development' ?
    storage.ref('/test-bd4a4153-6e39-4279-84c6-2ec431849fc3') : // Development.
    storage.ref('/live-60389412-b52f-4379-bb14-f332f173b191') // Live.

  const id = uuid()
  const timestamp = Date.now()

  const blobNames = Object.keys(blobs).map((name) => {
    const fileName = `${timestamp}_${name}_${healthStatus}_${gender}_${age}_${id}.wav`

    storageRef.child(fileName).put(blobs[name], { contentType: 'audio/wav' })

    return fileName
  })

  const data = {
    id,
    age,
    gender,
    healthStatus,
    conditions,
    symptoms,
    audioFiles: blobNames
  }

  return storageRef
    .child(`${timestamp}_${id}.json`)
    .put(new Blob([JSON.stringify(data)]), { contentType: 'application/json' })
}
